import { useState, useEffect, useCallback } from 'react';
import { useAuthService } from './authService';

export const useUserData = () => {
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuthService();

  const fetchUserData = useCallback(async () => {
    // Get the Cognito sub from the user object
    const cognitoSub = user?.attributes?.sub;
    
    console.log('User object:', user); // Debug log
    console.log('Cognito Sub:', cognitoSub); // Debug log
    
    if (!cognitoSub) {
      setError('No user ID available');
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const url = `https://wbx1c8we93.execute-api.us-east-1.amazonaws.com/get-user?userId=${cognitoSub}`;
      console.log('Fetching from URL:', url); // Debug log

      const response = await fetch(url);
      console.log('Response status:', response.status); // Debug log

      const responseText = await response.text();
      console.log('Raw response:', responseText); // Debug log

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      }

      const data = JSON.parse(responseText);
      console.log('Parsed data:', data); // Debug log
      setUserData(data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error('Error fetching user data:', err);
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  const updateUserData = useCallback(async (updates) => {
    const cognitoSub = user?.attributes?.sub;
    
    if (!cognitoSub) {
      throw new Error('No user ID available');
    }

    try {
      const url = `https://wbx1c8we93.execute-api.us-east-1.amazonaws.com/update-user?userId=${cognitoSub}`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updates)
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
      }

      const updatedData = await response.json();
      setUserData(updatedData);
      return updatedData;
    } catch (err) {
      console.error('Error updating user data:', err);
      throw err;
    }
  }, [user]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  // Expose refetch function to allow manual refresh of user data
  const refetch = () => {
    fetchUserData();
  };

  return { userData, isLoading, error, refetch, updateUserData };
}; 